import styled from 'styled-components';
import { maxDevice, minDevice } from '~/styles/breakpoints';

export const ToggleButton = styled.button`
    position: absolute;
    right: 60px;
    top: 60px;
    z-index: 11;

    height: 40px;
    width: 40px;

    padding: 8px;

    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #03a9f4;
    background: none;

    div {
        width: 100%;
        height: 2px;
        background: #03a9f4;

        margin: 3px 0;

        border-radius: 20px;
    }

    @media ${minDevice.laptop} {
        display: none;
    }
`;

export const NavMobile = styled.div`
    position: absolute;
    top: 0;
    bottom: 100%;
    left: 100%;
    right: 0;
    z-index: 10;

    display: flex;
    align-self: center;
    justify-content: center;

    overflow: hidden;

    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
    background-color: #333333;

    transition: all ease-in 0.2s;

    > ul {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        > li {
            text-align: center;

            padding: 10px 0;

            > a {
                font-size: 2rem;
                font-weight: 600;
                color: #03a9f4;

                padding: 10px 0;
            }
        }
    }

    &.active {
        bottom: 0;
        left: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

export const HeaderContainer = styled.header`
    height: 50px;
    width: 100%;

    position: absolute;
    top: 45px;

    z-index: 10;
`;

export const NavBar = styled.nav`
    display: flex;
    height: 100%;

    div {
        height: 100%;
        display: flex;
    }

    @media ${maxDevice.laptop} {
        display: none;
    }
`;

export const NavLeft = styled.div`
    flex: 2;
    justify-content: flex-end;
    ul {
        justify-content: flex-end;
        background: #03a9f4;
        /* border-bottom-left-radius: 15px; */
        > li > a {
            color: #292929;
        }
    }
`;

export const NavRight = styled.div`
    flex: 1;
    justify-content: flex-start;
    ul {
        justify-content: flex-start;
        background: #292929;
        /* border-top-right-radius: 15px; */
        > li > a {
            color: #03a9f4;
        }
    }
`;

export const NavList = styled.ul`
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0;
    list-style: none;
    > li {
        height: 100%;
        > a {
            display: block;

            font-size: 13px;
            font-weight: bold;
            text-transform: uppercase;
            text-decoration: none;

            line-height: 50px;

            height: 100%;
            padding: 0 15px;

            white-space: nowrap;
        }
    }
`;
